module.exports = __webpack_public_path__ + "static/scale-model-of-la-villita-historic-arts-village-in-san-antonio-texas-00861b54985add90258fec21d0292342.png";